import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-asthome',
    templateUrl: './asthome.component.html',
    styleUrls: ['./asthome.component.scss']
})
export class AsthomeComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titles: Title
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Undergraduate Courses for Science Students at ARNI School');
        this.meta.updateTag({
            name: 'description',
            content: `Explore undergraduate courses for science students at ARNI School of Technology. Prepare for a successful career with a top-tier education and hands-on experience.`
        });
    }

}
